import { render, staticRenderFns } from "./DefinicionesDeImpuestos.vue?vue&type=template&id=d5df4244"
import script from "./DefinicionesDeImpuestos.vue?vue&type=script&lang=js"
export * from "./DefinicionesDeImpuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports